import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GoogleAnalyticsService } from 'src/app/analytics/google.analytics.service';
import { AuthService } from 'src/app/auth/auth.service';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
    selector: 'app-additional-resend-contract',
    templateUrl: './additional-resend-contract.component.html',
    styleUrls: ['./additional-resend-contract.component.css']
})
export class AdditionalResendContractComponent implements OnInit {

    @Input() id = 0;
    @Input() statesOfIncorporation: any[] = [];
    @Input() defaultOfferId: any = 0;
    @Input() maxApprovedAmount: any = 0;

    @Output() reloadSlice = new EventEmitter<void>();

    public sendDocsForm: FormGroup;
    public invoiceAddressForm: FormGroup;

    public sendDocsFormSubmitted = false;
    public invoiceAddressFormSubmitted = false;

    public numberOfAttempts = 0;
    public numberOfDocsExceeded = false;

    public messageTitle = '';
    public messageMessageA = '';
    public messageMessageB = '';
    public messageMessageC = '';
    public messageMessageAClass = '';
    public messageMessageBClass = '';
    public messageMessageCClass = '';
    public dialogClass = '';

    public additionalResendContractModal = 'additionalResendContractModal' + this.id;
    public additionalSendContractsSuccessId = 'additionalSendContractsSuccess' + this.id;
    public additionalSummarySendDocsAddress = 'additionalSummarySendDocsAddress' + this.id;
    public additionalSendContractErrorDialog = 'AdditionalSendContractErrorDialog' + this.id;
    public additionalSendContractAttempDialog = 'additionalSendContractAttempDialog' + this.id;

    public defaultLeaseeAddress = {
        streetAddress: '',
        city: '',
        county: '',
        state: '',
        unit: '',
        zipCode: ''
    };

    public defaultSendDocsFormData = {
        invoiceNumber: '',
        ownerEmail: '',
        subTotal: '',
        ownerId: ''
    }

    public invoiceAddresArrays = {
        cities: [],
        states: [],
        counties: []
    };

    constructor(
        private authService: AuthService,
        private connectionService: ConnectionService,
        private formBuilder: FormBuilder,
        public googleAnalyticsService: GoogleAnalyticsService
    ) {
        this.sendDocsForm = this.formBuilder.group({
            sameInfo: ['true', Validators.required],
            invoiceNumber: [{ value: '', disabled: true }, Validators.required],
            ownerEmail: [{ value: '', disabled: true }, Validators.required],
            subTotal: [{ value: '', disabled: true }, Validators.required, this.requestedAmount.bind(this)]
        });

        this.invoiceAddressForm = this.formBuilder.group({
            sameAddres: ['true', Validators.required],
            address: [{ value: '', disabled: true }, Validators.required],
            unit: [{ value: '', disabled: true }],
            zip: [{ value: '', disabled: true }, Validators.required],
            city: [{ value: '', disabled: true }, Validators.required],
            state: [{ value: '', disabled: true }, Validators.required],
            county: [{ value: '', disabled: true }, Validators.required]
        });
    }

    ngOnInit() {
        this.additionalResendContractModal = 'additionalResendContractModal' + this.id;
        this.additionalSendContractsSuccessId = 'additionalSendContractsSuccess' + this.id;
        this.additionalSummarySendDocsAddress = 'additionalSummarySendDocsAddress' + this.id;
        this.additionalSendContractErrorDialog = 'AdditionalSendContractErrorDialog' + this.id;
        this.additionalSendContractAttempDialog = 'additionalSendContractAttempDialog' + this.id;
    }

    onClick() {
        this.googleAnalyticsService.trackEvent('additional-options', 'open', 'resend-contract');
        this.getApplication(this.id).then(
            () => this.getInvoice(this.id).then(
                () => $('#additionalResendContractModal' + this.id).modal()
            )
        );
    }

    onSendDocsToCustomerSubmit() {
        this.sendDocsFormSubmitted = true;
        if (this.sendDocsForm.invalid) {
            return;
        }

        this.changeOwnerEmail().then(
            () => this.offerInvoiceRecalc().then(
                () => {
                    $('#additionalResendContractModal' + this.id).modal('hide');
                    $('#additionalSummarySendDocsAddress' + this.id).modal()
                }
            )
        );
    }

    getInvoice(applicationId: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(environment.gateway + 'equipment/' + applicationId, 'application/json').subscribe(
                (data: any) => {
                    if (data.object) {
                        data.object.forEach((invoiceItem: any) => {
                            this.defaultSendDocsFormData.invoiceNumber = invoiceItem.make.replace('See invoice: ', '');
                            this.invoiceAddressForm.controls.sameAddres.setValue(invoiceItem.lesseeAddress ? 'true' : 'false');
                            this.invoiceAddressForm.controls.address.setValue(invoiceItem.streetAddress);
                            this.invoiceAddressForm.controls.unit.setValue(invoiceItem.unit);
                            this.invoiceAddressForm.controls.zip.setValue(invoiceItem.zipCode);
                            this.invoiceAddressForm.controls.city.setValue(String(invoiceItem.city).toUpperCase());
                            this.invoiceAddressForm.controls.state.setValue(invoiceItem.state);
                            this.invoiceAddressForm.controls.county.setValue(String(invoiceItem.county).toUpperCase());
                            this.sendDocsForm.controls.sameInfo.setValue('false');
                            this.changeSameAddress();
                            this.changeSameInfo();
                        });
                        if (data.object.length < 1) {
                            this.invoiceAddressForm.controls.sameAddres.setValue('true');
                            this.sendDocsForm.controls.sameInfo.setValue('true');
                            this.changeSameAddress();
                            this.changeSameInfo();
                        }
                    }
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
    }

    getInvoiceData(selectedOfferId: number) {
        return {
            equipmentList: [
                {
                    city: this.invoiceAddressForm.controls.city.value,
                    condition: 'true',
                    cost: this.sendDocsForm.controls.subTotal.value,
                    county: this.invoiceAddressForm.controls.county.value,
                    description: '',
                    lesseeAddress: this.invoiceAddressForm.controls.sameAddres.value === 'true',
                    make: 'See invoice: ' + this.sendDocsForm.controls.invoiceNumber.value,
                    model: 'See invoice: ' + this.sendDocsForm.controls.invoiceNumber.value,
                    serialNumber: '',
                    state: this.invoiceAddressForm.controls.state.value,
                    streetAddress: this.invoiceAddressForm.controls.address.value,
                    supplier: '',
                    unit: this.invoiceAddressForm.controls.unit.value,
                    year: new Date().getFullYear(),
                    zipCode: this.invoiceAddressForm.controls.zip.value
                }
            ],
            offerId: selectedOfferId
        };
    }

    changeSameAddress() {
        if (this.invoiceAddressForm.controls.sameAddres.value == 'true') {
            this.invoiceAddressForm.controls.address.setValue(this.defaultLeaseeAddress.streetAddress);
            this.invoiceAddressForm.controls.unit.setValue(this.defaultLeaseeAddress.unit);
            this.invoiceAddressForm.controls.zip.setValue(this.defaultLeaseeAddress.zipCode);
            this.invoiceAddressForm.controls.city.setValue(String(this.defaultLeaseeAddress.city).toUpperCase());
            this.invoiceAddressForm.controls.state.setValue(this.defaultLeaseeAddress.state);
            this.invoiceAddressForm.controls.county.setValue(String(this.defaultLeaseeAddress.county).toUpperCase());
            this.invoiceAddressForm.controls.address.disable();
            this.invoiceAddressForm.controls.unit.disable();
            this.invoiceAddressForm.controls.zip.disable();
            this.invoiceAddressForm.controls.city.disable();
            this.invoiceAddressForm.controls.county.disable();
            this.onZipCodeKeyUp(
                this.defaultLeaseeAddress.state,
                String(this.defaultLeaseeAddress.city).toUpperCase(),
                String(this.defaultLeaseeAddress.county).toUpperCase()
            );
        } else {
            this.invoiceAddressForm.controls.address.enable();
            this.invoiceAddressForm.controls.unit.enable();
            this.invoiceAddressForm.controls.zip.enable();
            this.invoiceAddressForm.controls.city.enable();
            this.invoiceAddressForm.controls.county.enable();
            this.onZipCodeKeyUp();
        }
    }

    changeSameInfo() {
        if (this.sendDocsForm.controls.sameInfo.value != 'true') {
            this.sendDocsForm.controls.invoiceNumber.setValue(this.defaultSendDocsFormData.invoiceNumber);
            this.sendDocsForm.controls.subTotal.setValue(this.defaultSendDocsFormData.subTotal);
            this.sendDocsForm.controls.ownerEmail.setValue(this.defaultSendDocsFormData.ownerEmail);
            this.sendDocsForm.controls.invoiceNumber.disable();
            this.sendDocsForm.controls.subTotal.disable();
            this.sendDocsForm.controls.ownerEmail.disable();
        } else {
            this.sendDocsForm.controls.invoiceNumber.enable();
            this.sendDocsForm.controls.subTotal.enable();
            this.sendDocsForm.controls.ownerEmail.enable();
        }
    }

    onZipCodeKeyUp(state?: any, city?: any, county?: any) {
        this.getZipCodeData(this.invoiceAddressForm.controls.zip.value).then(
            (data: any) => {
                if (data.object) {
                    this.invoiceAddresArrays.cities = data.object.city;
                    this.invoiceAddresArrays.states = this.statesOfIncorporation;
                    this.invoiceAddresArrays.counties = data.object.county;
                    this.invoiceAddressForm.controls.state.setValue(state ? state : data.object.state);
                    if (data.object.city.length > 0) this.invoiceAddressForm.controls.city.setValue(city ? city : data.object.city[0]);
                    if (data.object.county.length > 0) this.invoiceAddressForm.controls.county.setValue(county ? county : data.object.county[0]);
                } else {
                    this.invoiceAddresArrays.cities = [];
                    this.invoiceAddresArrays.counties = [];
                }
            },
            (error: any) => {
                this.invoiceAddresArrays.cities = [];
                this.invoiceAddresArrays.counties = [];
            }
        );
    }

    getInvoiceAddress() {
        return [{
            city: this.invoiceAddressForm.controls.city.value,
            county: this.invoiceAddressForm.controls.county.value,
            state: this.invoiceAddressForm.controls.state.value,
            zipCode: this.invoiceAddressForm.controls.zip.value
        }];
    }

    getZipCodeData(zipCode: string) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(environment.gateway + 'application/zipData/' + zipCode, 'application/json').subscribe(
                (data: any) => {
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
    }

    changeOwnerEmail() {
        return new Promise((resolve, reject) => {
            this.connectionService.postRequest(environment.gateway + 'application/owneremail', {}, 'application/json',
                'applicationId=' + this.id + '&ownerId=' + this.defaultSendDocsFormData.ownerId + '&email=' + this.sendDocsForm.controls.ownerEmail.value).subscribe(
                    (data: any) => {
                        if (this.defaultSendDocsFormData.ownerEmail != this.sendDocsForm.controls.ownerEmail.value) {
                            this.googleAnalyticsService.trackEvent('additional-options', 'guarantor-email-changed', 'resend-contract');
                        }
                        resolve(data);
                    },
                    (error: any) => {
                        resolve(error);
                    }
                );
        });
    }

    offerInvoiceRecalc() {
        return new Promise((resolve, reject) => {
            this.connectionService.postRequest(
                environment.gateway + 'application/' + this.defaultOfferId + '/offerInvoiceRecalc/' + this.authService.getUserId(),
                { newRequestAmount: this.sendDocsForm.controls.subTotal.value }, 'application/json',
                'sp_id=' + this.authService.getSalesPersonId()).subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        resolve(error);
                    }
                );
        });
    }

    getApplication(appId: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(
                environment.gateway + 'application/' + appId, 'application/json', 'sp_id=' + this.authService.getSalesPersonId()).subscribe(
                    (data: any) => {
                        if (data.object) {
                            this.defaultLeaseeAddress = {
                                streetAddress: data.object.lessee.address,
                                city: data.object.lessee.city,
                                county: data.object.lessee.county,
                                state: data.object.lessee.state,
                                unit: data.object.lessee.unit,
                                zipCode: data.object.lessee.zipCode
                            };

                            this.defaultSendDocsFormData.subTotal = data.object.requestedAmount;
                            data.object.lessee.owners.forEach((ow: any) => {
                                if (ow.primaryOwner) {
                                    this.defaultSendDocsFormData.ownerEmail = ow.email;
                                    this.defaultSendDocsFormData.ownerId = ow.id;
                                }
                            });
                        }
                        resolve(data);
                    },
                    (error: any) => {
                        resolve(error);
                    }
                );
        });
    }

    onSubmitInvoiceDialog() {
        this.invoiceAddressFormSubmitted = true;
        if (this.invoiceAddressForm.invalid) {
            return;
        }

        this.validateQuantity().then(
            (data: any) => {
                this.numberOfDocsExceeded = data.object.numberOfDocsExceeded;
                if (data.object.attemptNumber < 1) {
                    this.openSelectOffersDialogAfterQuantityValidation();
                } else if (data.object.attemptNumber > 0) {
                    $('#additionalSummarySendDocsAddress' + this.id).modal('hide');
                    this.numberOfAttempts = data.object.attemptNumber;
                    $('#additionalSendContractAttempDialog' + this.id).modal({ backdrop: 'static', keyboard: false });
                }
            },
            (error: any) => {
                this.messageTitle = 'Sorry, we found a problem';
                this.messageMessageA = 'Unfortunately we are unable to process your request at this moment.';
                this.messageMessageB = error.error.msg;
                this.messageMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                this.messageMessageBClass = 'mB20';
                this.dialogClass = 'w600';
                $('#additionalSummarySendDocsAddress' + this.id).modal('hide');
                $('#errorModalDialogAdditionalSendContractErrorDialog' + this.id).modal();
            }
        );
    }

    validateQuantity() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(
                environment.gateway + 'validateQuantity/' + this.id, 'application/json').subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
    }

    openSelectOffersDialogAfterQuantityValidation() {
        this.multipleAddressValidation().then(
            (addressData: any) => {
                this.sendDocsToCustomer(Number(this.defaultOfferId));
            },
            (addressError: any) => {
                this.messageTitle = 'Sorry, we found a problem';
                this.messageMessageA = 'Unfortunately we are unable to process your request at this moment.';
                this.messageMessageB = addressError.error.msg;
                this.messageMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                this.messageMessageBClass = 'mB20';
                this.dialogClass = 'w600';
                $('#additionalSummarySendDocsAddress' + this.id).modal('hide');
                $('#errorModalDialogAdditionalSendContractErrorDialog' + this.id).modal();
            }
        );
    }

    multipleAddressValidation() {
        return new Promise((resolve, reject) => {
            this.connectionService.postRequest(
                environment.gateway + 'multipleaddressvalidation/', this.getInvoiceAddress(), 'application/json').subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
    }

    sendDocsToCustomer(selectedOffer: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.postRequest(
                environment.gateway + 'equipment/' + this.id + '/' + this.authService.getUserId(),
                this.getInvoiceData(selectedOffer), 'application/json').subscribe(
                    (data: any) => {
                        this.googleAnalyticsService.trackEvent('additional-options', 'sent', 'resend-contract');
                        resolve(data);
                        $('#additionalSummarySendDocsAddress' + this.id).modal('hide');
                        $('#additionalSendContractsSuccess' + this.id).modal();
                    },
                    (error: any) => {
                        this.messageTitle = 'Sorry, we found a problem';
                        this.messageMessageA = 'Unfortunately we are unable to process your request at this moment.';
                        this.messageMessageB = error.msg;
                        this.messageMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                        this.messageMessageBClass = 'mB20';
                        this.dialogClass = 'w600';
                        $('#additionalSummarySendDocsAddress' + this.id).modal('hide');
                        $('#errorModalDialogAdditionalSendContractErrorDialog' + this.id).modal();
                        reject(error);
                    }
                );
        });
    }

    onCloseModal() {
        this.reloadSlice.emit();
        this.ngOnInit();
    }

    requestedAmount(control: FormControl) {
        if (control.errors && !control.errors.requestedAmount) {
            return;
        }

        if (control.value < 500) {
            control.setErrors({ requestedAmount: true });
        } else {
            control.setErrors(null);
        }
        return new Promise((resolve, reject) => { });
    }
}